export const CHANGE_TAB = 'CHANGE_TAB';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SHOW_LOADER = 'SHOW_LOADER';